import React, { useEffect, useContext } from "react"
import styled from "styled-components";
import PrimaryLinkButton from "../Button/PrimaryLinkButton";
import SecondButton from "../Button/SecondButton";
import LineArrowRight from "../Icons/LineArrowRight";
import PhoneIcon from "../Icons/PhoneIcon";
import NoteIcon from "../Icons/NoteIcon";
import { Context } from "../../layouts/context";

const ProductToolbar = styled.div`
  display:flex;
  flex-wrap:wrap;  
  margin:0 -5px;
  @media(min-width:768px){
    margin:0 -10px;
  }
`
const ProductItemTool = styled.div`
 position:relative;
 width:100%;
 flex: 0 0 auto;
 width: auto;
 max-width: none;
 padding:0 5px;
 @media(min-width:768px){
    padding:0 10px;
 }
`

const ProductButtons = () => {
  const {popupContext, setPopupContext} = useContext(Context);
      const HandleModalOpen = () => {
        setPopupContext({
          isVisible: true
        })
      }
      useEffect(() => {
          if (popupContext.isVisible===true) {
              document.querySelector("body").classList.add("modal-open")
          } else {
              document.querySelector("body").classList.remove("modal-open")
          }
      }, [popupContext, setPopupContext])
  return (
    <ProductToolbar>
      <ProductItemTool>
        <a href="tel:3867556449" aria-label="(386) 755-6449"><SecondButton text="(386) 755-6449" preIcon={<PhoneIcon fill="#fff" />} /></a>
      </ProductItemTool>
      <ProductItemTool>
        <button type="button" onClick={HandleModalOpen} aria-hidden="true"><PrimaryLinkButton text="Get a quote" preIcon={<NoteIcon />} icon={<LineArrowRight />} /></button>        
      </ProductItemTool>
    </ProductToolbar>
  );
};

export default ProductButtons;
